import React from 'react';
import './Process.css';

const Process = () => {
  const steps = [
    {
      number: '01',
      title: 'Discovery & Audit',
      description: 'We dive deep into your business goals, target audience, and current digital presence to identify opportunities for growth.'
    },
    {
      number: '02',
      title: 'Strategy Development',
      description: 'Our team crafts a custom, data-driven digital marketing strategy tailored specifically to achieve your unique objectives.'
    },
    {
      number: '03',
      title: 'Implementation',
      description: 'We execute the strategy with precision, launching campaigns, optimizing content, and setting up tracking.'
    },
    {
      number: '04',
      title: 'Analysis & Scaling',
      description: 'We continuously monitor performance, refine our approach based on data, and scale what works to maximize ROI.'
    }
  ];

  return (
    <section className="process" id="process">
      <div className="container">
        <div className="process-header">
          <span className="section-tag">How We Work</span>
          <h2 className="section-title">
            Our Proven <span className="highlight">Process</span>
          </h2>
          <p className="section-subtitle">
            A systematic approach to driving sustainable growth for your business.
          </p>
        </div>

        <div className="process-grid">
          {steps.map((step, index) => (
            <div className="process-card" key={index}>
              <div className="process-number">{step.number}</div>
              <h3 className="process-title">{step.title}</h3>
              <p className="process-description">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
